import React from "react";

import AddIcon from "@mui/icons-material/Add";
import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";
// import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Button, Stack } from "@mui/material";
import { EditSquare } from "assets/material-custom-icons";
import { InlineFilter } from "components/Filters/InlineFilter";
import { RoleComponentGuard } from "components/guards/Role-component.guard";
import { DealCreate, DealCreateFromFile } from "components/modals";
import { Menu } from "components/popups";
// import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useCanCreateDeal, useNavigate, usePrompt } from "hooks";
import {
  useAccountSelector,
  useDealActions,
  useDealFiltersSelector,
  useDealQueriesSelect,
  useReportsActions
} from "store";

import { RoleName } from "../../../constants";
import { StyledStack } from "../Dashboard/StyledStack";
import { InputFilter } from "../Filters/InputFilter";
import { OrderBy } from "../OrderBy/OrderBy";

export const DealsToolbar: React.FC = () => {
  const { updateQueries } = useDealActions();
  const { setQueriesAction } = useReportsActions();
  const { filters: queriesFilters } = useDealQueriesSelect();
  const filtersList = useDealFiltersSelector();
  const openPrompt = usePrompt();
  const navigate = useNavigate();
  const canCreateDeal = useCanCreateDeal();
  const {
    show_global_investor_filter,
    allow_dataroom: isDataRoomsEnabled,
    allow_import_deal_from_excel: isImportFromExcelEnabled
  } = useAccountSelector() || {};
  // const { downloadDealsListFileAction } = useDealActions();

  const createDeal = async () => {
    const data = await openPrompt({ Component: DealCreate, props: {} });

    if (!data) return;

    navigate({ route: "deal", params: { deal_id: data.id } });
  };

  const createDealFromFile = async () => {
    const data = await openPrompt({ Component: DealCreateFromFile });

    if (!data) return;

    navigate({ route: "deal", params: { deal_id: data.id } });
  };
  // const queries = useDealQueriesSelect();

  // const handleDownloadDeals = () => {
  //   downloadDealsListFileAction({
  //     filters: queries.filters,
  //     deal_title: queries.deal_title,
  //     order_by: queries.order_by,
  //     columns: queries.tableColumns
  //   });
  // };

  return (
    <StyledStack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
      <Stack
        direction="row"
        alignItems="flex-start"
        sx={{
          flexWrap: "wrap",
          gap: "15px",
          maxHeight: "125px",
          overflow: "auto"
        }}
      >
        <InlineFilter
          handleChangeFilter={(filters) => {
            updateQueries({ filters });
            show_global_investor_filter && setQueriesAction({ filters });
          }}
          filtersList={filtersList}
          applyMode={true}
          state={queriesFilters}
        />
      </Stack>
      <Stack direction="row" alignItems="center" gap="10px">
        {/* <MaterialTooltip title="Download Deals List" isShow>
          <IconButton onClick={handleDownloadDeals}>
            <FileDownloadOutlinedIcon sx={{ color: "#0a3142", width: "20px", height: "20px" }} />
          </IconButton>
        </MaterialTooltip> */}
        <InputFilter />
        <OrderBy />
        <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]} hideChild={!canCreateDeal}>
          {isDataRoomsEnabled ? (
            <Menu
              iconButtonProps={{ sx: { padding: 0, width: "auto" } }}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              icon={
                <Button
                  sx={{
                    textTransform: "none",
                    maxHeight: "27px !important",
                    minHeight: "27px !important",
                    whiteSpace: "nowrap"
                  }}
                  startIcon={<AddIcon />}
                  variant="contained"
                >
                  Add Deal
                </Button>
              }
              options={[
                {
                  title: "Import From Dataroom / Investor Portal",
                  icon: <CloudSyncOutlinedIcon sx={{ color: "#0a3142" }} />,
                  onClick: () => {
                    navigate({ route: "dataRooms" });
                  }
                },
                {
                  title: "Start From Scratch",
                  icon: <EditSquare id="createDealModal" sx={{ color: "#0a3142", fill: "#0a3142" }} />,
                  onClick: createDeal
                },
                {
                  title: "Starting From File",
                  icon: <UploadFileIcon sx={{ color: "#0a3142" }} />,
                  onClick: createDealFromFile,
                  hidden: !isImportFromExcelEnabled
                }
              ]}
            />
          ) : (
            <Button
              sx={{
                textTransform: "none",
                maxHeight: "27px !important",
                minHeight: "27px !important",
                whiteSpace: "nowrap"
              }}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={createDeal}
            >
              Add Deal
            </Button>
          )}
        </RoleComponentGuard>
      </Stack>
    </StyledStack>
  );
};
